import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { DashboardHttpService } from 'src/app/http/dashboard-http.service';
import { SharedService } from 'src/app/services/shared.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styles: [],
})
export class HomeComponent implements OnInit, OnDestroy {
    constructor(private activatedRoute: ActivatedRoute, private dashboardHttpService: DashboardHttpService, public sharedService: SharedService) {}

    dataModel: any;

    dashboardReport: any;

    @ViewChild(AlertComponent) alert: AlertComponent;

    subscription: Subscription;

    ngOnInit(): void {
        this.routeHistory();
        this.routeData();
        this.getDashboardReportInterval();
        this.sharedService.accessOrdersList = true;
        this.sharedService.accessComplainsList = true;
    }

    getDashboardReportInterval() {
        this.subscription = interval(60000).subscribe(() => {
            this.getDashboardReport();
        });
    }

    getDashboardReport() {
        this.dashboardHttpService.getDashboardReport().subscribe((data) => {
            this.dashboardReport = data;
        });
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.dashboardReport = data.data;
        });
    }

    routeHistory() {
        if (history.state.hasState) {
            setTimeout(() => {
                this.alert.addAlert({ type: history.state.type, message: history.state.message });
            });
        }
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
